import React from "react";
import UseGetDashBoardDataPro from "../../../../Components/Hooks/UseGetDashBoardDataPro";

const Budget = () => {
  const { data, loading } = UseGetDashBoardDataPro(`/Dashboard/projects/budget`);

   const renderProgressBlocks = (percentage) => {
    const totalBlocks = 10;
    const filledBlocks = Math.round((percentage / 100) * totalBlocks);

    return (
      <div className="flex items-center gap-0.5">
        {Array.from({ length: totalBlocks }).map((_, index) => (
          <div
            key={index}
            className={`w-2.5 h-2 rounded-full ${
              index < filledBlocks ? "bg-green-500" : "bg-gray-300"
            }`}
          ></div>
        ))}
      </div>
    );
  };

  return (
    <div className="bg-white p-4 rounded-lg drop-shadow-lg h-[45vh] 2xl:h-[35vh] w-full overflow-hidden">
      <div className="flex justify-between border-b pb-2">
        <h2 className="font-semibold text-[#4F4768] text-sm">Project Budget & Spending</h2>
        <p className="text-right text-sm text-[#4F4768]">Currency: SAR</p>
      </div>

      <div className="w-full h-[96%] overflow-y-scroll pb-4">
          <table className="w-full">
            <thead className="sticky top-0 bg-white shadow-sm">
                <tr className="border-b text-left">
              <th className="py-1 font-semibold text-xs text-[#4F4768]">Project</th>
              <th className="py-1 font-semibold text-xs text-[#4F4768]">Status</th>
              <th className="py-1 font-semibold text-xs text-[#4F4768]">Allocated</th>
              <th className="py-1 font-semibold text-xs text-[#4F4768]">Spent</th>
              <th className="py-1 font-semibold text-xs text-[#4F4768]">Remaining</th>
            </tr>
          </thead>
          <tbody className="overflow-y-scroll">
            {data?.projects?.length > 0 ? (
              data.projects.map((project, index) => {
                const percentage = project.allocated > 0 ? ((project.spent / project.allocated) * 100).toFixed(2) : 0;

                return (
                  <tr key={index} className="text-sm text-gray-700 border-b last:border-b-0 ">
                          <td className="py-2">
                      <p className="font-medium text-[#4F4768] text-xs">{project.name}</p>
                      <div className="flex items-center gap-2">
                        {renderProgressBlocks(percentage)}
                        <p className="font-thin text-[#059E4B] text-xs">{percentage}%</p>
                      </div>
                    </td>

                         <td className="py-2 text-blue-500 text-xs capitalize">{project.status}</td>

                        <td className="py-2 text-[#4F4768] text-xs">{project.allocated.toLocaleString()}</td>

                           <td className="py-2 text-[#4F4768] text-xs">{project.spent.toLocaleString()}</td>

                         <td className="py-2 text-[#4F4768] text-xs">{project.remaining.toLocaleString()}</td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan="5" className="py-4 text-center text-gray-500 text-xs">
                  No projects available.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Budget;
